// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".subcards-inventoryBar__jBupW{display:flex;flex-wrap:wrap;gap:var(--size-2);align-items:center;padding:var(--size-3) var(--size-4);background:var(--gray-a2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inventoryBar": "subcards-inventoryBar__jBupW"
};
export default ___CSS_LOADER_EXPORT___;
